export default function getInitState() {
    return {
        viewDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        viewRowActions: [],
        viewActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showViewSearchModal'
            }
        ],
        viewSearchFields: [
            {
                name: "status",
                label: "Státusz",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {id: 'CREA', text: 'Létrehozva'},
                        {id: 'PEDDING', text: 'Küldés alatt'},
                        {id: 'DONE', text: 'Kiküldve'},
                        {id: 'ERROR', text: 'Hiba'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "recipient",
                label: "Címzett",
                formSize: 3,
                formVisible: true,
                formType: "text"
            },
            {
                name: "subject",
                label: "Tárgy",
                formSize: 3,
                formVisible: true,
                formType: "text"
            },
            {
                name: "createDateFrom",
                label: "Létrehozás dátuma (tól)",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "createDateTo",
                label: "Létrehozás dátuma (ig)",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            }
        ],
        viewHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "status",
                label: "Státusz",
                slot_name: "email_status_format",
                visibility: true
            },
            {
                name: "sender",
                label: "Küldő",
                visibility: true
            },
            {
                name: "recipient",
                label: "Címzett",
                visibility: true
            },
            {
                name: "subject",
                label: "Tárgy",
                visibility: true
            },
            {
                name: "createDate",
                label: "Készítés dátuma",
                slot_name: "created_on_format",
                sort: true,
                visibility: true
            },
            {
                name: "sendDate",
                label: "Kiküldés dátuma",
                slot_name: "modified_on_format",
                visibility: true
            },
            {
                name: "errorMessage",
                label: "Hiba",
                visibility: true
            }
            /*{
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }*/
        ],

        reportDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        reportRowActions: [],
        reportActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showReportSearchModal'
            }
        ],
        reportSearchFields: [
            {
                name: "status",
                label: "Státusz",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {id: 'CREA', text: 'Létrehozva'},
                        {id: 'PEDDING', text: 'Küldés alatt'},
                        {id: 'DONE', text: 'Kiküldve'},
                        {id: 'ERROR', text: 'Hiba'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "subject",
                label: "Tárgy",
                formSize: 3,
                formVisible: true,
                formType: "text"
            },
            {
                name: "createDateFrom",
                label: "Létrehozás dátuma (tól)",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "createDateTo",
                label: "Létrehozás dátuma (ig)",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            }
        ],
        reportHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "status",
                label: "Státusz",
                slot_name: "email_status_format",
                visibility: true
            },
            {
                name: "subject",
                label: "Tárgy",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                slot_name: "date_format",
                sort: true,
                visibility: true
            },
            {
                name: "count",
                label: "Darabszám",
                visibility: true
            }
            /*{
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            // }*/
        ]
    }
}
